// extracted by mini-css-extract-plugin
export default {"body":"confirm-your-address-popup__body____mWcz","title":"confirm-your-address-popup__title___aL1RH","content":"confirm-your-address-popup__content___DcWhK"};